import React from "react";
import { formatPrice } from "../../util/format";
import {
  FreeShippingContainer,
  FreeShippingText,
  FreeShippingBar,
  FreeShippingBarFill,
} from "./styles";

export default function FreeShippingProgress({ valorMinimo, base }) {
  const minimo = Number(valorMinimo) || 0;
  const total = Number(base) || 0;

  if (!minimo) return null;

  const atingiu = total >= minimo;
  const percentual = atingiu
    ? 100
    : Math.max(0, Math.min(100, (total / minimo) * 100));

  return (
    <FreeShippingContainer>
      <FreeShippingText atingiu={atingiu}>
        {atingiu
          ? "Você ganhou frete grátis"
          : `Faltam ${formatPrice(minimo - total)} para frete grátis`}
      </FreeShippingText>
      <FreeShippingBar>
        <FreeShippingBarFill
          percentual={percentual}
          atingiu={atingiu}
        />
      </FreeShippingBar>
    </FreeShippingContainer>
  );
}
